import { useEffect, useState } from "react";
import AddSection from "./AddSection";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { COURSE_SECTION_FETCH_ERROR, COURSE_SECTION_FETCH_START, COURSE_SECTION_FETCH_SUCCESS, COURSE_SECTION_TOTAL_PAGE, DELETE_COURSE_SECTION_ROUTE, EDIT_COURSE_SECTION_SUCCESS } from "../../../Reducer/courseSectionSlice";
import { MY_COURSE_FETCH_SUCCESS } from "../../../Reducer/myCourseSlice";
import toast from "react-hot-toast";
import API from "../../../Network/API";
import EditSection from "./EditSection";
import AddLesson from "../Lesson/AddLesson";
import EditLesson from "../Lesson/EditLesson";
import { useTranslation } from "react-i18next";

export default function CourseSection() {
  const { t } = useTranslation();
  const select_sections = useSelector((state) => state.courseSectionReducer);
  const select_course = useSelector((state) => state.myCourseReducer);
  const [course_id, setCourseId] = useState(null);
  const [show, setShow] = useState(false);
  const [show_edit, setShowEdit] = useState(false);
  const prams = useParams();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [section_id, setSectionId] = useState(0);
  const [row_data, setRowData] = useState(null);
  const [course, setData] = useState(null);
  const [show_lesson, setShowLesson] = useState(false);
  const [show_edit_lesson, setShowLessonEdit] = useState(false);
  const [lesson_data, setLessonData] = useState(null);
  const [error, setError] = useState(null);
  const handleShow = (row) => {
    setShow(!show)
    setCourseId(row)
  };

  const handleShowEdit = (row) => {
    setShowEdit(!show_edit)
    setCourseId(prams?.id)
    setRowData(row)
  };

  const handleShowLesson = (row) => {
    setShowLesson(!show_lesson)
    setCourseId(prams?.id)
    setRowData(row)
  };

  const handleShowEditLesson = (row, section) => {
    setShowLessonEdit(!show_edit_lesson)
    setCourseId(prams?.id)
    setRowData(section)
    setLessonData(row)
  };


  useEffect(() => {
    // resolve the course (needed by the lesson modals); fetch on refresh/deep link
    const found = select_course?.courses?.find(course => course.id == prams.id && course.title !== undefined);
    if (found) {
      setData(found);
    } else {
      API.get(`/v1/oauth/teacher/mycourses`).then((response) => {
        dispatch(MY_COURSE_FETCH_SUCCESS(response.data.data));
        setData(response.data.data?.courses?.find(course => course.id == prams.id));
      }).catch(() => {});
    }

    dispatch(COURSE_SECTION_FETCH_START())
    API.get(`/v1/oauth/teacher/sections/${prams?.id}`).then((response) => {
      dispatch(COURSE_SECTION_FETCH_SUCCESS(response.data.data))
      dispatch(COURSE_SECTION_TOTAL_PAGE(response.data.data.total_page))
    }).catch((error) => {
      dispatch(COURSE_SECTION_FETCH_ERROR())
      toast.error(t("courseSection.load_failed"))
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prams?.id]);

  const delete_section = (id) => {
    if (!window.confirm(t("courseSection.confirm_delete_section"))) return;
    setSectionId(id)
    setLoading(true)
    API.delete('/v1/oauth/teacher/sections/' + id + '').then((response) => {
      setLoading(false)
      dispatch(DELETE_COURSE_SECTION_ROUTE(id))
      toast.success(t("courseSection.section_deleted"))
    }).catch((error) => {
      setLoading(false)
      toast.error(error.response?.data?.message || t("courseSection.delete_section_failed"));
    });
  }

  const delete_lesson = (row) => {
    if (!window.confirm(t("courseSection.confirm_delete_lesson"))) return;
    setLessonData(row)
    setLoading(true)
    API.delete('/v1/oauth/teacher/lesson/' + row?.id + '').then((response) => {
      setLoading(false)
      dispatch(EDIT_COURSE_SECTION_SUCCESS(response?.data.data))
      toast.success(t("courseSection.lesson_deleted"))
    }).catch((error) => {
      setLoading(false)
      toast.error(error.response?.data?.message || t("courseSection.delete_lesson_failed"));
    });
  }

  return (
    <>
      <div className="AddlessonWrapperHeading mb-3">
        <h2>{t("courseSection.lesson")}</h2>
      </div>
      <div className="AddlessonWrapper card">
        <div>
          <a onClick={() => handleShow(prams?.id)} role="button" className="btn btn-sm btn-outline-dark mt-2 ms-3">
            <i className="fa-light fa-plus" />
            {t("courseSection.add_section")}
          </a>
        </div>
        <div className="card-body">
          <div className="Addlessoninner">

            {select_sections?.loading &&
              <p className="text-center text-muted py-4 mb-0">{t("courseSection.loading_sections")}</p>
            }
            {!select_sections?.loading && !(select_sections?.main_data?.length > 0) &&
              <div className="text-center text-muted py-5">
                <i className="fa-light fa-layer-group d-block mb-2" style={{ fontSize: 28 }} />
                {t("courseSection.no_sections")}
              </div>
            }
            {!select_sections?.loading && select_sections?.main_data?.length > 0 && select_sections?.main_data?.slice()
              .sort((a, b) => a.serial_no - b.serial_no).map((section, j) => (

                <div className="singleLesson mb-3" key={j}>
                  <div className="singleLessonWrapper bg-light p-4 rounded">
                    <div className="singleLessonHeading fs-16-400 mb-3">
                      <span className="fw-semibold me-1">{t("courseSection.section_number", { number: j + 1 })}</span>
                      <span className="me-1 text-muted"><i className="fa-light fa-file" /></span>
                      <span className="text-muted">{section?.name}</span>
                    </div>
                    <div className="singleLessonAddContent ">
                      <div className="bg-white p-2 border rounded">
                        {section?.lessons?.slice()
                          .sort((a, b) => a.serial_no - b.serial_no).map((lesson, k) => (
                            <div className="d-flex justify-content-between align-items-center mb-2" key={lesson.id ?? k}>
                              <div className="LessonAddContentleft text-muted">
                                <span className="me-1"><i className="fa-solid fa-check-circle me-1 text-dark" />{t("courseSection.lecture_number", { number: ++k })}</span>
                                <span className="me-1"><i className="fa-light fa-file" /></span>
                                <span className>{lesson.title}</span>
                              </div>
                              <div className="LessonAddContentRight">
                                <a onClick={() => handleShowEditLesson(lesson, section)} role="button" className="btn btn-sm btn-outline-dark">
                                  <i className="fa-light fa-pencil" />
                                </a>
                                <a onClick={() => delete_lesson(lesson)} role="button" className="btn btn-sm btn-outline-danger ms-2">
                                  <i className="fa-light fa-trash" />
                                  {lesson_data?.id == lesson?.id && isLoading ? (
                                    <span
                                      className="spinner-border spinner-border-sm ml-5"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) : (
                                    <span></span>
                                  )}
                                </a>
                              </div>
                            </div>
                          ))}

                      </div>
                      <a onClick={() => handleShowLesson(section)} role="button" className="btn btn-sm btn-outline-dark mt-2">
                        <i className="fa-light fa-plus me-2" />
                        {t("courseSection.add_lesson")}
                      </a>

                      <a onClick={() => handleShowEdit(section)} role="button" className="btn btn-sm btn-outline-success mt-2 ms-2">
                        <i className="fa-light fa-plus me-2" />
                        {t("courseSection.edit_section")}
                      </a>

                      <a onClick={() => delete_section(section?.id)} role="button" className="btn btn-sm btn-outline-danger mt-2 ms-2">
                        <i className="fa-light fa-remove me-2" />
                        {t("courseSection.delete_section")} {section_id == section?.id && isLoading ? (
                          <span
                            className="spinner-border spinner-border-sm ml-5"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <span></span>
                        )}
                      </a>

                    </div>
                  </div>

                </div>
              ))}

          </div>
        </div>
      </div>
      <AddSection show={show} onHide={handleShow} course_id={course_id} />
      <EditSection show={show_edit} onHide={handleShowEdit} course_id={course_id} data={row_data} />

      <AddLesson course={course} show={show_lesson} onHide={handleShowLesson} data={row_data} />
      <EditLesson course={course} show={show_edit_lesson} onHide={handleShowEditLesson} data={row_data} lesson={lesson_data} />
    </>
  )
}